import * as THREE from 'three'
import { FBXLoader } from 'three/addons/loaders/FBXLoader.js'
import { normalizeAssetUrl } from '../../config'
import { resolveAlignCheckerTextureUrl } from '../../utils/alignCheckerTexture'

// Helper to create FBXLoader with normalized URL resolution
// This ensures all URLs (including relative paths resolved by FBXLoader) are normalized to HTTPS
export const createNormalizedFBXLoader = (): FBXLoader => {
  const manager = new THREE.LoadingManager()
  const originalResolveURL = manager.resolveURL.bind(manager)
  manager.resolveURL = (url: string) => {
    // Normalize all URLs (HTTP -> HTTPS)
    const normalizedUrl = normalizeAssetUrl(url)
    const stubbed = resolveAlignCheckerTextureUrl(normalizedUrl)
    if (stubbed !== normalizedUrl) {
      return stubbed
    }
    const resolved = originalResolveURL(normalizedUrl)
    return normalizeAssetUrl(resolved)
  }
  return new FBXLoader(manager)
}
